import { render } from "./TotalPrice.vue?vue&type=template&id=d661c264&scoped=true"
import script from "./TotalPrice.vue?vue&type=script&lang=js"
export * from "./TotalPrice.vue?vue&type=script&lang=js"

import "./TotalPrice.vue?vue&type=style&index=0&id=d661c264&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d661c264"]])

export default __exports__